import { render, staticRenderFns } from "./updateMajor.vue?vue&type=template&id=437f1562&scoped=true"
import script from "./updateMajor.vue?vue&type=script&lang=js"
export * from "./updateMajor.vue?vue&type=script&lang=js"
import style0 from "./updateMajor.vue?vue&type=style&index=0&id=437f1562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f1562",
  null
  
)

export default component.exports